import React, { useState } from 'react'
import clsx from 'clsx'
import { PlusMinus } from '../../../components/PlusMinus'
import { StatsJoueurDetails } from '../StatsJoueurDetails'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import { toStructureLogoSrc } from '../../../shared/competitionUrls'
import { RankedRow } from '../data'
import styles from './styles.module.scss'
import { StructureLogoOrGeneric } from '../../../components/StructureLogoOrGeneric'
import { booleanBitStringToBoolean } from '../../../shared/utils'

export const StatsJoueurRow = ({ data }: { data: RankedRow }) => {
    const [open, setOpen] = useState(false)
    const { isDesktop, fetchDetails, fetchingDetails, joueurType } = useStatsJoueursDataContext()

    const isFetchingDetails = fetchingDetails === data.individuId

    const logo = booleanBitStringToBoolean(data.showEquipeLogo) ? (
        <StructureLogoOrGeneric
            imageUrl={toStructureLogoSrc(data.structureLogo, 64)}
            title={data.equipeLibelle}
        />
    ) : null

    const totalScores = joueurType === 'joueur_de_champ' ? data.totalButs : data.totalArrets

    return (
        <>
            <button
                onClick={() => {
                    setOpen((v) => !v)
                    fetchDetails(data.individuId)
                }}
                className={clsx(styles.row, open && styles.open)}
            >
                <div className={styles.rank}>{data.rank}</div>
                <div className={styles.name}>{`${data.prenom} ${data.nom}`}</div>
                <div className={styles.club}>
                    {isDesktop ? (
                        <>
                            <div className={styles.equipeLogoWrapper}>{logo}</div>
                            <div>{data.equipeLibelle}</div>
                        </>
                    ) : (
                        logo
                    )}
                </div>
                <div className={styles.num1}>{totalScores}</div>
                <div className={styles.num2}>{data.matchCount}</div>
                <div className={styles.num3}>
                    {(Number(totalScores) / Number(data.matchCount || 1)).toLocaleString('fr', {
                        maximumFractionDigits: 1,
                    })}
                </div>
                <div className={styles.toggle}>
                    <PlusMinus open={open} style={{ fontSize: 10 }} />
                    {isDesktop ? <>&nbsp;&nbsp;stats</> : ''}
                </div>
            </button>
            <div
                className={clsx(
                    styles.details,
                    open && styles.open,
                    isFetchingDetails && styles.fetching,
                )}
            >
                <StatsJoueurDetails individuId={data.individuId} />
            </div>
        </>
    )
}
